import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { translate } from 'utils/translate';

interface OpenCommentModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;
    data: any;
    actions: ActionsType | undefined;
}

interface OpenCommentModelState {
    //unused state
    errors: object;

    data: any | null;
}

class OpenCommentModel extends Component<OpenCommentModelProps, OpenCommentModelState> {
    constructor(props: OpenCommentModelProps) {
        super(props);
        this.state = {
            data: props.data,
            errors: {},
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        const parser = new DOMParser();
        const doc = parser.parseFromString(this.props.data.text, 'text/html');
        const comments = Array.from(doc.body.children);
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-4 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Read comment')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <div className="font-bold">{this.props.data.email}</div>
                    <div className="text-gray-400">{this.props.data.created_at}</div>
                    <div className="my-2">
                        {comments.map((el, index) => (
                            <div
                                className="text-gray-400"
                                key={index}
                                dangerouslySetInnerHTML={{ __html: el.outerHTML }}
                            />
                        ))}
                    </div>

                    <div className="flex justify-end border-t border-gray-400">
                        <div className="mt-2">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const openCommentModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const openCommentModelDispatchToProps = () => ({});

export default connect(openCommentModelStateToProps, openCommentModelDispatchToProps)(OpenCommentModel);
